type ConsolidationContainerLabelInfo = {
  label: string;
  demonstrative: "denne" | "dette";
  /** Definite form, e.g. "paragraffen". */
  definite: string;
  /** Locative phrase, e.g. "i paragrafen". */
  definiteIn: string;
};

const CONTAINER_TYPE_LABELS: Record<string, ConsolidationContainerLabelInfo> = {
  PARAGRAF: {
    label: "paragraf",
    demonstrative: "denne",
    definite: "paragraffen",
    definiteIn: "i paragrafen",
  },
  KAPITEL: {
    label: "kapitel",
    demonstrative: "dette",
    definite: "kapitlet",
    definiteIn: "i kapitlet",
  },
  AFSNIT: {
    label: "afsnit",
    demonstrative: "dette",
    definite: "afsnittet",
    definiteIn: "i afsnittet",
  },
  BILAG: {
    label: "bilag",
    demonstrative: "dette",
    definite: "bilaget",
    definiteIn: "i bilaget",
  },
  GROUP_HEADING: {
    label: "gruppeoverskrift",
    demonstrative: "denne",
    definite: "gruppeoverskriften",
    definiteIn: "i gruppeoverskriften",
  },
};

const DEFAULT_CONTAINER_LABEL: ConsolidationContainerLabelInfo = {
  label: "afsnit",
  demonstrative: "dette",
  definite: "afsnittet",
  definiteIn: "i afsnittet",
};

export const getConsolidationContainerLabelInfo = (
  containerType: string | null | undefined
): ConsolidationContainerLabelInfo | null => {
  if (!containerType) return null;
  return CONTAINER_TYPE_LABELS[containerType] ?? null;
};

export const getConsolidationContainerTypeLabel = (
  containerType: string | null | undefined
): string | null => getConsolidationContainerLabelInfo(containerType)?.label ?? null;

export const getConsolidationInstructionPanelSubtitle = (
  containerType: string | null | undefined,
  hasMultipleChanges: boolean
): string => {
  const { demonstrative, label } =
    getConsolidationContainerLabelInfo(containerType) ?? DEFAULT_CONTAINER_LABEL;

  if (hasMultipleChanges) {
    return `Instruktionerne bag ændringerne af ${demonstrative} ${label}, i rækkefølge`;
  }

  return `Instruktionen bag ændringen af ${demonstrative} ${label}`;
};

export const getConsolidationNoChangesMessage = (
  containerType: string | null | undefined
): string => {
  const { demonstrative, label } =
    getConsolidationContainerLabelInfo(containerType) ?? DEFAULT_CONTAINER_LABEL;

  return `Ingen ændringer registreret for ${demonstrative} ${label}.`;
};

export const getConsolidationCannotHighlightDiffMessage = (
  containerType: string | null | undefined
): string => {
  const { definiteIn } =
    getConsolidationContainerLabelInfo(containerType) ?? DEFAULT_CONTAINER_LABEL;

  return `Kunne ikke fremhæve præcis ændring ${definiteIn}.`;
};

export const getConsolidationFullInsertionMessage = (
  containerType: string | null | undefined
): string => {
  const { definite } =
    getConsolidationContainerLabelInfo(containerType) ?? DEFAULT_CONTAINER_LABEL;

  return `Hele ${definite} er indsat som ny tekst.`;
};

export const getConsolidationFullDeletionMessage = (
  containerType: string | null | undefined
): string => {
  const { definite } =
    getConsolidationContainerLabelInfo(containerType) ?? DEFAULT_CONTAINER_LABEL;

  return `Hele ${definite} er fjernet.`;
};
